import { sizeTab, texto, a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";

import SolicitudIngresoEnEsperaPagina from "./revision-solicitudes-ingreso-en-espera/revisionSolicitudesIngresoEnEsperaPage";
// import SolicitudIngresoAprobadasPagina from "./revision-solicitudes-Ingreso-aprobadas/revisionSolicitudesIngresoAprobadasPage";
import SolicitudIngresoRechazadosPagina from "./revison-solicitudes-ingreso-rechazados/revisionSolicitudesIngresoRechazadosPage";
import RevisionSolicitudIngresoFinalizado from "./revision-solicitudes-ingreso-finalizados/revisionSolicitudesIngresoFinalizados";
import SolicitudIngresoAprobadasPagina from "./revision-solicitudes-ingreso-aprobadas/revisionSolicitudesIngresoAprobadasPage";

export default function RevisionSolicitudIngresoPagina() {


  const [valueTab, setValueTab] = useState(0);

  return (

    <SingleTableBoxScene title={"Revisión de Solicitudes de Compra"}>
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs solicitud pedidos"
        >
          <Tab label={texto.solicitud_espera} {...a11yProps(0)} />
          <Tab label={texto.solicitudes_aprobadas} {...a11yProps(1)} />
          <Tab label={texto.solicitud_rechazada} {...a11yProps(2)} />
          <Tab label={'Solicitud finalizadas'}{...a11yProps(3)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <SolicitudIngresoEnEsperaPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <SolicitudIngresoAprobadasPagina/>
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <SolicitudIngresoRechazadosPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={3}>
        <RevisionSolicitudIngresoFinalizado/>
      </CustomTabPanel>

    </SingleTableBoxScene>
  );
}


